import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapPaymentMethod'
})
export class MapPaymentMethodPipe implements PipeTransform {

  // Return the available parental ratings
  getMethod(selection) {
    let methods = [{
      id: 0,
      icon: "K"
    },{
      id: 1,
      icon: "fab fa-cc-paypal"
    },{
      id: 2,
      icon: "far fa-credit-card"
    }];
    return methods.filter(obj =>  obj.id == selection)[0];
  }
  
  transform(method: any, ...args: unknown[]): unknown {
    return this.getMethod(method).icon;
  }
}
